import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import {
  SimpleGrid,
  Stack,
  Flex,
  InputGroup,
} from "@chakra-ui/react";

import {
  Search,
} from "lucide-react";

import ReusableInput from "components/Inputs/ReusableInput";
import NoDataFound from "components/NoDataGraphics/NoDataFound";

import DriverPartnerSupportCard from "./components/DriverPartnerSupportCard";
import UpdateSupportTicketDrawer from "./components/UpdateSupportTicketDrawer";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  fetchDriverPartnersSupportTicketsAction,
  updateDriverPartnerSupportTicketAction,
} from "state/actions/driverPartnerSupportActions";

const DriverPartnerSupportTab = () => {
  const dispatch = useDispatch();

  const {
    tickets,
    loading,
  } = useSelector(
    (state) => state.driverPartnerSupport
  );

  const supportTickets = tickets?.data || [];

  const [searchTerm, setSearchTerm] =
    useState("");

  const [
    selectedTicket,
    setSelectedTicket,
  ] = useState(null);

  const [
    isViewDrawerOpen,
    setViewDrawerOpen,
  ] = useState(false);

  useEffect(() => {
    dispatch(
      fetchDriverPartnersSupportTicketsAction(
        1,
        10
      )
    );
  }, [dispatch]);

  const handleOpenDrawer = (
    ticket
  ) => {
    setSelectedTicket(ticket);
    setViewDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setSelectedTicket(null);
    setViewDrawerOpen(false);
  };

  const handleUpdateTicket = async (
    ticketId,
    payload
  ) => {
    const response =
      await dispatch(
        updateDriverPartnerSupportTicketAction(
          ticketId,
          payload
        )
      );

    if (response?.success) {
      dispatch(
        fetchDriverPartnersSupportTicketsAction(
          1,
          10
        )
      );

      handleCloseDrawer();
    }

    return response;
  };

  const filteredTickets =
    supportTickets.filter(
      (ticket) => {
        const search =
          searchTerm.toLowerCase();

        return (
          ticket.subject
            ?.toLowerCase()
            .includes(search) ||
          ticket.category
            ?.toLowerCase()
            .includes(search) ||
          ticket.status
            ?.toLowerCase()
            .includes(search)
        );
      }
    );

  return (
    <Stack spacing={5}>
      <Flex
        justifyContent="space-between"
        alignItems="center"
      >
        {loading ? (
          <Skeleton
            width="300px"
            height="40px"
            borderRadius="12px"
            ml={5}
          />
        ) : (
          <InputGroup
            width="300px"
            ml={5}
            borderRadius="12px"
          >
            <ReusableInput
              icon={
                <Search
                  size={20}
                  color="#A0AEC0"
                />
              }
              placeholder="Search tickets..."
              value={searchTerm}
              onChange={(e) =>
                setSearchTerm(
                  e.target.value
                )
              }
            />
          </InputGroup>
        )}
      </Flex>

      <SimpleGrid
        columns={{
          base: 1,
          md: 2,
          lg: 3,
          xl: 4,
        }}
        spacing={5}
        p={5}
      >
        {filteredTickets.map(
          (ticket) => (
            <DriverPartnerSupportCard
              key={
                ticket.ticket_id
              }
              {...ticket}
              loading={loading}
              onView={() =>
                handleOpenDrawer(
                  ticket
                )
              }
            />
          )
        )}
      </SimpleGrid>

      {!loading &&
        filteredTickets.length ===
          0 && (
          <Flex
            justifyContent="center"
            alignItems="center"
            height="300px"
            width="100%"
          >
            <NoDataFound message="No support tickets found." />
          </Flex>
        )}

      {selectedTicket && (
        <UpdateSupportTicketDrawer
          isOpen={
            isViewDrawerOpen
          }
          onClose={
            handleCloseDrawer
          }
          ticket={selectedTicket}
          onUpdateTicket={
            handleUpdateTicket
          }
        />
      )}
    </Stack>
  );
};

export default DriverPartnerSupportTab;